import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { ResetRouteState, SetSelectedRouteFromRouteState } from './route.actions';

export interface RouteModel {
  selectedRoute: string;
  previousRoute: string;
}

export const defaultRouteState: RouteModel = {
  selectedRoute: 'home',
  previousRoute: '',
};

@State<RouteModel>({
  name: 'route',
  defaults: defaultRouteState,
})
@Injectable()
export class RouteState {
  @Selector()
  static getSelectedRouteFromRouteState(state: RouteModel): string {
    return state.selectedRoute;
  }

  @Selector()
  static getPreviousRouteFromRouteState(state: RouteModel): string {
    return state.previousRoute;
  }

  @Action(SetSelectedRouteFromRouteState)
  setSelectedRoute({ getState, patchState }: StateContext<RouteModel>, action: SetSelectedRouteFromRouteState) {
    const previousRoute = getState().selectedRoute;
    patchState({ selectedRoute: action.route, previousRoute });
  }

  @Action(ResetRouteState)
  resetState({ setState }: StateContext<RouteModel>) {
    setState(defaultRouteState);
  }
}

